import { API } from '../constants/api';

import { axiosInterceptor } from './interceptors';

// Clears the account setup dismissed flag so it shows again on fresh login.
// Called before every login flow that issues a new session token.
const clearSetupDismissed = () => localStorage.removeItem('cp_setup_dismissed');

export const getUser = async () => {
    const response = await axiosInterceptor.get(API.USER.GET);

    return response;
};

export const login = async (payload: any) => {
    clearSetupDismissed();
    const response: any = await axiosInterceptor.post(API.AUTH.LOGIN, payload);

    if (response?.code) {
        localStorage.setItem('code', response.code);
    }

    if (response?.token) {
        localStorage.setItem('token', response.token);
    }

    return response;
};

export const resetNewPassword = async (payload: any) => {
    const response: any = await axiosInterceptor.post(API.AUTH.RESET_PASSWORD, payload);

    if (response?.token) {
        localStorage.setItem('token', response.token);
    }

    return response;
};

export const verify = async (payload: any) => {
    const response: any = await axiosInterceptor.post(API.AUTH.VERIFICATION, payload);

    return response;
};

export const verifyPassword = async (payload: any) => {
    clearSetupDismissed();
    const response: any = await axiosInterceptor.post(API.AUTH.VERIFY_PASSWORD, payload);
    localStorage.setItem('token', response?.token || null);

    return response;
};

export const sendOtp = async (payload: any) => {
    const response: any = await axiosInterceptor.post(API.AUTH.SEND_OTP, payload);

    if (response?.code) {
        localStorage.setItem('code', response.code);
    }

    return response;
};

export const verifyOtp = async (payload: any) => {
    const response: any = await axiosInterceptor.post(API.AUTH.VERIFY_OTP, payload);

    return response;
};

export const getDetail = async (custId: any) => {
    const response: any = await axiosInterceptor.get(`${API.USER.GET_DETAIL}/${custId}`);

    return response;
};

export const microsoftLogin = async () => {
    const response: any = await axiosInterceptor.post(`${API.AUTH.FETCH_MICROSOFT_LOGIN}`);
    localStorage.clear();
    localStorage.setItem('verifier', response.data.verifier);

    return response;
};

export const verifyCode = async (payload: any) => {
    clearSetupDismissed();
    const response: any = await axiosInterceptor.post(API.AUTH.VERIFY_CODE, payload);
    localStorage.setItem('token', response?.token || null);

    return response;
};

export const saveUserBasicDetails = async (payload: any) => {
    const response: any = await axiosInterceptor.put(API.USER.UPDATE_USER_DETAILS, payload);

    return response;
};

export const updateUserWidgets = async (data: any) => {
    const response: any = await axiosInterceptor.patch(API.USER.UPDATE_WIDGET_SETTINGS, data);

    return response;
};

export const googleLogin = async (payload: any) => {
    clearSetupDismissed();
    const response: any = await axiosInterceptor.post(API.AUTH.GOOGLE_LOGIN, payload);
    localStorage.setItem('token', response?.token || null);

    return response;
};

// WAL internal-user flow (Microsoft SSO + customer selection) — replaces the legacy
// super-admin impersonation. Both endpoints require the 15m selection token in localStorage.
export const getWalCustomers = async (params?: { search?: string; limit?: number }) => {
    const response: any = await axiosInterceptor.get(API.AUTH.WAL_CUSTOMERS, { params });

    return response;
};

export const walSelect = async (payload: { customerMasterId: number }) => {
    const response: any = await axiosInterceptor.post(API.AUTH.WAL_SELECT, payload);

    if (response?.token) {
        localStorage.setItem('token', response.token);
    }

    return response;
};
